module.exports = __webpack_public_path__ + "img/labmemtest_btn_download_jp.f876efd9.png";